import { Button } from 'vnetwork-ui'

interface ButtonSkeletonProps {
    width?: number
}

const ButtonSkeleton = ({ width = 120 }: ButtonSkeletonProps) => {
    return (
        <Button
            size="small"
            className={`w-full h-9 min-w-[120px] ${width ? `w-[${width}px]` : ''} bg-gray-200 animate-pulse rounded-sm`}
        />
    )
}

export default ButtonSkeleton
